import { CountryCode } from '@src/types/common';

export interface PendingReason {
  id: number;
  name: string;
}

export interface PendingReasonsByCountry {
  [key: string]: PendingReason[];
}

// Razones pendientes por país
export const PENDING_REASONS_BY_COUNTRY: PendingReasonsByCountry = {
  [CountryCode.CRC]: [
    // Costa Rica
    { id: 1, name: 'Faltan firmas' },
    { id: 2, name: 'Falta firma del inspector' },
    { id: 3, name: 'DEKRA vencido' },
    { id: 4, name: 'VIN incorrecto' },
    { id: 5, name: 'Odómetro incorrecto' },
    { id: 6, name: 'Botón de investigación inactivo' },
    { id: 7, name: 'Placa metálica incorrecta' },
    { id: 8, name: 'Observaciones incompletas' },
    { id: 9, name: 'Cédula del asegurado incorrecta' },
    { id: 10, name: 'Fecha de nacimiento incorrecta' },
    { id: 11, name: 'Circunstancias del accidente incompletas' },
    { id: 12, name: 'Botón de lesionados inactivo' },
    { id: 13, name: 'Botón de oficial presente inactivo' },
    { id: 14, name: 'Falta DEKRA del asegurado' },
    { id: 15, name: 'Falta marchamo del asegurado' },
    { id: 16, name: 'Falta cédula del asegurado' },
    { id: 17, name: 'Razón de pacto amistoso incorrecta' },
    { id: 18, name: 'Falta DEKRA de la contraparte' },
    { id: 19, name: 'Falta marchamo de la contraparte' },
    { id: 20, name: 'Falta cédula de la contraparte' },
    { id: 21, name: 'Falta boleta de tránsito' },
    { id: 22, name: 'Falta lugar de inspección' },
    { id: 23, name: 'Falta información del accidente' },
    { id: 24, name: 'Faltan fotos del vehículo asegurado' },
    { id: 25, name: 'Faltan fotos de documentos del asegurado' },
    { id: 26, name: 'Faltan fotos panorámicas' },
    { id: 27, name: 'Faltan fotos de documentos de la contraparte' },
    { id: 28, name: 'Faltan fotos del vehículo contraparte' },
    { id: 29, name: 'Relato incoherente' },
    { id: 30, name: 'Falta relato de los hechos' },
  ],
  [CountryCode.PAN]: [
    // Panamá
    { id: 101, name: 'Falta FUD' },
    { id: 102, name: 'FUD mal diligenciado' },
    { id: 103, name: 'Falta colilla de tránsito' },
    { id: 104, name: 'Falta licencia del asegurado' },
    { id: 105, name: 'Faltan fotos de documentos del asegurado' },
    { id: 106, name: 'Faltan fotos del vehículo asegurado' },
    { id: 107, name: 'Faltan fotos de documentos de la contraparte' },
    { id: 108, name: 'Faltan fotos del vehículo de la contraparte' },
    { id: 109, name: 'Falta foto del VIN y odómetro' },
    { id: 110, name: 'Falta parte trasera de la licencia' },
    { id: 111, name: 'Resolución del inspector no es clara' },
    { id: 112, name: 'Información del SIC no coincide con los documentos' },
    { id: 113, name: 'Faltan fotos panorámicas' },
    { id: 114, name: 'Falta firma del inspector' },
    { id: 115, name: 'Relato incoherente' },
    { id: 116, name: 'Falta el relato de los hechos' },
    { id: 117, name: 'Falta observación del inspector' },
    { id: 118, name: 'Falta daños del vehículo' },
  ],
  [CountryCode.PRI]: [
    // Puerto Rico
    { id: 201, name: 'Faltan firmas' },
    { id: 202, name: 'Falta firma del inspector' },
    { id: 203, name: 'Falta licencia del vehículo' },
    { id: 204, name: 'Falta sello de AutoExpreso' },
    { id: 205, name: 'Falta millaje (odómetro)' },
    { id: 206, name: 'Faltan fotos laterales trasera' },
    { id: 207, name: 'Faltan fotos laterales frontal' },
    { id: 208, name: 'Falta foto frontal' },
    { id: 209, name: 'Falta foto del baúl abierto' },
    { id: 210, name: 'Falta foto del bonete abierto' },
    { id: 211, name: 'Falta foto del tablero (dash)' },
    { id: 212, name: 'Faltan fotos panorámicas' },
    { id: 213, name: 'Estimado incompleto o de baja calidad' },
    { id: 214, name: 'Faltan páginas del informe policíaco' },
    { id: 215, name: 'Faltan fotos de documentos de la contraparte' },
    { id: 216, name: 'Faltan fotos del vehículo contraparte' },
    { id: 217, name: 'Relato incoherente' },
    { id: 218, name: 'Falta relato de los hechos' },
    { id: 219, name: 'Licencia de conducir' },
    { id: 220, name: 'Fotos de daños' },
    { id: 221, name: 'VIN number' },
  ],
  [CountryCode.COL]: [
    // Colombia
    { id: 301, name: 'Falta FUD' },
    { id: 302, name: 'FUD mal diligenciado' },
    { id: 303, name: 'Falta colilla de tránsito' },
    { id: 304, name: 'Falta licencia del asegurado' },
    { id: 305, name: 'Faltan fotos de documentos del asegurado' },
    { id: 306, name: 'Faltan fotos del vehículo asegurado' },
    { id: 307, name: 'Faltan fotos de documentos de la contraparte' },
    { id: 308, name: 'Faltan fotos del vehículo de la contraparte' },
    { id: 309, name: 'Falta foto del VIN y odómetro' },
    { id: 310, name: 'Falta parte trasera de la licencia' },
    { id: 311, name: 'Resolución del inspector no es clara' },
    { id: 312, name: 'Información del SIC no coincide con los documentos' },
    { id: 313, name: 'Faltan fotos panorámicas' },
    { id: 314, name: 'Falta firma del inspector' },
    { id: 315, name: 'Relato incoherente' },
    { id: 316, name: 'Falta el relato de los hechos' },
    { id: 317, name: 'Falta observación del inspector' },
    { id: 318, name: 'Falta daños del vehículo' },
  ],
};

export const getPendingReasonsByCountry = (
  countryCode: CountryCode,
): PendingReason[] => {
  return PENDING_REASONS_BY_COUNTRY[countryCode] || [];
};

export const getAllPendingReasons = (): PendingReason[] => {
  return Object.values(PENDING_REASONS_BY_COUNTRY).flat();
};

export const getPendingReasonById = (id: number): PendingReason | undefined => {
  return getAllPendingReasons().find((reason) => reason.id === id);
};

export default PENDING_REASONS_BY_COUNTRY;
